import { EvtHeader } from "components/header";
import Loader from "@/components/loader";
import ProjectForm from "@/modules/work/projects/project/crud/form";
import React from "react";
import { useProject } from "@/modules/work/projects/context";

const UpdateProject = () => {
  const { data, isLoading } = useProject();
  if (isLoading) return <Loader />;
  return (
    <div className="flex-1">
      <EvtHeader title="Update Project" />
      <div className="p-6 max-w-md">
        <ProjectForm projectId={data.id} />
      </div>
    </div>
  );
};

export default UpdateProject;
